
import { defineComponent, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

import ApiService from "@/core/services/ApiService";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";

interface Connection {
  id: string;
  conn_name: string;
  scheme: string;
  host: string;
  domain: string;
  auth_type: string;
  payload_type: string;
  response_type: string;
  enabled: string;
  conn_status: string;
  category: string;
  created: string;
  modified: string;
  logo_url: string;
}

interface Endpoint {
  id: string;
  connection_id: string;
  endpoint_name: string;
  method: string;
  custom_host: string;
  endpoint_path: string;
  enabled: string;
  endpoint_status: string;
  parameters: string;
  created: string;
  modified: string;
}

export default defineComponent({
  name: "add_portal_drawer",
  emit: ["submit"],
  setup(props, { emit }) {
    onMounted(async () => {
      const { data } = await ApiService.get(
        "apis/connections?limit=100&group[category]=Portal"
      );
      if (data.success) {
        connections.value = [...data.data];
      }

      const res = await ApiService.get("apis/endpoints?limit=100");
      if (res.data.success) {
        endpoints.value = [...res.data.data];
      }

      connEndOptions.value = connections.value.map((conn) => {
        const connEndpoints = endpoints.value.filter(
          (end) => end.connection_id === conn.id
        );

        const ends = connEndpoints.map((end) => {
          return {
            value: end.id,
            label: end.endpoint_name,
          };
        });

        return {
          value: conn.id,
          label: conn.conn_name,
          children: ends,
        };
      });
    });
    const alias_name = ref("");
    const store = useStore();
    const route = useRoute();
    const submitButton = ref<HTMLButtonElement | null>(null);
    const connections = ref<Connection[]>([]);
    const endpoints = ref<Endpoint[]>([]);
    const parameters = ref<unknown>(null);

    const selectedConnEnd = ref([]);

    const selConnEnd = (value) => {
      const selectedEnd = endpoints.value.find(
        (end) => end.connection_id === value[0] && end.id === value[1]
      );
      if (selectedEnd) {
        parameters.value = JSON.parse(selectedEnd.parameters);
      } else {
        parameters.value = null;
      }
    };

    const formSubmit = async () => {
      if (!selectedConnEnd.value[0]) {
        return;
      }

      // eslint-disable-next-line
      submitButton.value!.disabled = true;
      // Activate indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");

      // eslint-disable-next-line
      const payload: any = {
        customer_id: store.getters.currentUser.data.customer_id,
        connection_id: selectedConnEnd.value[0],
        endpoint_id: selectedConnEnd.value[1],
        alias_name: alias_name.value,
        merchant_id: route.params.id,
        group_id: store.getters.currentUser.data.companygroupid,
        parameters: parameters.value,
      };

      try {
        const res = await ApiService.post("apis/merchants", payload);
        if (res.data.success) {
          Swal.fire({
            text: "You have successfully added the merchant portal!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            DrawerComponent?.getInstance("add_portal_drawer")?.hide();
            emit("submit");
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }

      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    const connEndOptions = ref<unknown[]>([]);

    return {
      connEndOptions,
      alias_name,
      selConnEnd,
      selectedConnEnd,
      parameters,
      submitButton,
      formSubmit,
    };
  },
});
